import React from "react";

const linkSosmed = () =>
    <ul>
      <li>
        <a href="https://www.facebook.com/solahuddin.hafid">
          <span className="fa fa-facebook"></span>
        </a>
      </li>
      <li>
        <a href="https://twitter.com/SOlah03">
          <span className="fa fa-twitter"></span>
        </a>
      </li>
      <li>
        <a href="https://www.instagram.com/salahuddin_hafid/">
          <span className="fa fa-instagram"></span>
        </a>
      </li>
      <li>
        <a href="https://github.com/Dinel13">
          <span className="fa fa-github"></span>
        </a>
      </li>
      <li >
        <a href="https://www.linkedin.com/in/salahuddin-hafid">
          <span className="fa fa-linkedin"></span>
        </a>
      </li>
    </ul>

export default linkSosmed;
